import {
    EpgProgram,
    MixedItem,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

function useProgramCountriesStr(
    item:
        | EpgProgram
        | RBProgram
        | MixedItem
        | VodEditorial
        | RecordingItem
        | undefined,
) {
    if (!item) {
        return '';
    }

    const detailedItem = item as EpgProgram | RBProgram | VodEditorial;

    const countries = detailedItem.Countries ?? (item as MixedItem).countries;

    let result = '';

    if (countries) {
        result = `${countries.split(';')[0]} `;
    }

    return result;
}

export default useProgramCountriesStr;
